import React from 'react';
import cardImg from '../../../assets/image/homepageback.png'
// import './Categories.scss'
import { Link } from 'react-router-dom';
import './Card/Card.scss'
const Categories = () => {
    const categories = [
        {
            title:' Huquiqiy bilimni oshirish',
            img:cardImg
        },
        {
            title:' Huquiqiy bilimni oshirish',
            img:cardImg
        },
        {
            title:' Huquiqiy bilimni oshirish, Huquiqiy bilimni oshirish',
            img:cardImg
        }
    ]




    return (
        <div className="categories-sec container">
            <div className="bg-text">Kategoriyalar</div>
            <h3>Kategoriyalar</h3>
            <div className="categories ">
                {
                    categories.map(category=>{
                        return <Link to='/categories/courses' className="card" >
                            <div className="img-box">
                            <img src={category.img} className="card-img-top" /> </div>
                            <div className="card-body d-flex flex-column justify-contnet-center align-items-center">
                                <div className="card-title">{category.title}</div>
                            </div>
                       
                    </Link>
                    })
                }
            </div>
        </div>
    );
}

export default Categories;
